// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1KF7R","question":"Question_question__3Pl7x","description":"Question_description__9y8Ln"};